export default __webpack_public_path__ + "static/media/Support.8a4a4a23.svg";